import React from 'react'

export interface SVGXIconProps {
  width?: string;
  height?: string;
  color?: string;
}

export const SVGXIcon = ({
  width = '32',
  height = '32',
  color = '#000000',
}: SVGXIconProps) => (
  <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.333 0A5.333 5.333 0 0 0 0 5.333v21.334A5.333 5.333 0 0 0 5.333 32h21.334A5.333 5.333 0 0 0 32 26.667V5.333A5.333 5.333 0 0 0 26.667 0zm1.59 6.857h6.047l4.295 6.103 5.211-6.103h1.905l-6.256 7.325 7.714 10.96h-6.046l-4.983-7.08-6.048 7.08H6.857l7.092-8.301zm2.916 1.524 10.749 15.238h2.335L12.174 8.381z" fill={color}/>
  </svg>
)
